"use strict";
import { useContext } from "react";
import { OwnerModuleContext } from "../context";
export function useOwnerModule() {
  const info = useContext(OwnerModuleContext);
  return info;
}
